import "./Card.css";

function CardLoading() {
  return (
    <div className="card-skeleton">
      <div className="shimmer card-skeleton__image" />
      <div className="shimmer card-skeleton__line" />
      <div className="shimmer card-skeleton__line card-skeleton__line--short" />
      <div className="shimmer card-skeleton__btn" />
    </div>
  );
}

export default CardLoading;
